import type { CServicesTranslations } from "./pl";

export const en: CServicesTranslations = {
  emptyData: "No data to display.",
  emptyList: "No services to display.",
  readMore: "View service",
  inPreparationBadge: "In preparation",
};
